var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAreaChart = function SvgAreaChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M725.333 320 512 149.333 298.667 448 128 320v554.667h768V320zm85.334 424.533L512 512 341.333 746.667l-128-102.4v-153.6l104.107 78.08 211.627-296.533 166.4 133.12h115.2v339.2z"
  })));
};
export default SvgAreaChart;